import { sendGet, sendPost, sendPut } from "~/api/base";
import { getAPIData } from "../helpers";
import {
  ICreationStorePreferences,
  IStoreConnect,
  IStoreLoginRequest,
} from "./types";

export const getStoreInfo = () => getAPIData(sendGet("shop/"));

export const storeLogin = (params: IStoreLoginRequest) =>
  getAPIData(sendPost("shop_login/", params));

export const storeConnect = (params: IStoreConnect) =>
  getAPIData(sendPost("connect/shopify/", params));

export const getShopifyProducts = () =>
  getAPIData(sendGet("shopify/products/"));

export const getShopifyCollections = () =>
  getAPIData(sendGet("shopify/collections/"));

export const sendCustomizationStorePreferences = async ({
  selectedBestDescribedWord,
  selectedColorScheme,
  selectedRegion,
  selectedStoreCategory,
}: ICreationStorePreferences) => {
  return sendPost("dropgenius/quiz", {
    category: selectedStoreCategory,
    color_scheme: selectedColorScheme,
    region: selectedRegion,
    store_personality: selectedBestDescribedWord,
  });
};
